<template>
  <div class="relative">
    <VueLoading :active.sync="loading" :is-full-page="false" />
    <StatCard
      title="Alerts"
      :value="alerts"
      :change="changePercentage"
      :isPositive="changePercentage >= 0"
      customClass="alerts-stat-card"
    />
  </div>
</template>

<script>
import StatCard from './StatCard.vue'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'AlertsStatCard',
  components: {
    StatCard,
    VueLoading
  },
  props: {
    id: {
      type: String,
      default: 'AllContracts'
    }
  },
  data () {
    return {
      loading: false,
      alerts: 0,
      changePercentage: 0
    }
  },
  computed: {
    ...mapGetters(['activeType'])
  },
  methods: {
    getMonthString (offset = 0) {
      var now = new Date()
      now.setMonth(now.getMonth() + offset)
      var year = now.getFullYear()
      var month = (now.getMonth() + 1).toString().padStart(2, '0')
      return year + '-' + month
    },
    sumAlertTotals (alertData) {
      var sum = 0
      if (alertData && typeof alertData === 'object') {
        for (var priority in alertData) {
          if (
            alertData[priority] &&
            typeof alertData[priority].total === 'number'
          ) {
            sum += alertData[priority].total
          }
        }
      }
      return sum
    },
    fetchAlerts () {
      this.loading = true

      var currentMonth = this.getMonthString(0)
      var previousMonth = this.getMonthString(-1)

      var currentTotal = 0
      var previousTotal = 0

      HTTP.get(`/alerts/summary/${this.activeType}/${this.id}/month/${currentMonth}`)
        .then(response => {
          currentTotal = this.sumAlertTotals(
            response && response.data && response.data.alerts
          )

          return HTTP.get(`/alerts/summary/${this.activeType}/${this.id}/month/${previousMonth}`)
        })
        .then(response => {
          previousTotal = this.sumAlertTotals(
            response && response.data && response.data.alerts
          )

          this.alerts = currentTotal
          this.changePercentage =
            previousTotal !== 0
              ? (((currentTotal - previousTotal) / previousTotal) * 100).toFixed(2)
              : 0
        })
        .catch(error => {
          console.error('Failed to fetch alerts:', error.message)
          this.alerts = 0
          this.changePercentage = 0
          if (this.flashMessage && typeof this.flashMessage.error === 'function') {
            this.flashMessage.error({
              message: `Failed to get alerts: ${(error.response && error.response.data && error.response.data.error) || error.message}`
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.fetchAlerts()
      }
    }
  }
}
</script>

<style scoped>
.alerts-stat-card {
  border-left: 4px solid #ef4444; /* Red tone for alerts */
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/AlertsStatCard.vue